import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CryptocurrencyEditFormFields } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/CryptocurrencyEditFormFields";
import { useEditCryptocurrencyForm } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/useEditCryptocurrencyForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditCryptocurrencyFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditCryptocurrencyForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditCryptocurrencyFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } =
		useEditCryptocurrencyForm({
			portfolioId,
			portfolio,
			detailRoute,
		});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<CryptocurrencyEditFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
